<template>
<div class="recruitPopWrap">
	<div class="recruitPopBox">

		<div class="jobTitleWrap">
			<div class="in">
				<h4 class="title">게임사업 부문</h4>
			</div>
		</div>

		<div class="jobListWrap">
			<ul class="jobList">
				<li class="job1">
					<h5 class="jobName">Data Science</h5>
					<ul class="description">
						<li class="intro">
							<span class="tit">소개</span>
							<span>광고와 마케팅의 기획, 집행, 효과분석을 위해 관련된 각종 데이터를 수집하고 분석하여 인사이트 도출하는 업무</span>
						</li>
						<li class="position">
							<span class="tit">직무</span>
							<ul>
								<li>기존의 광고캠페인리포트 및 수집 가능한 광고 관련 기타 데이터들의 수집, 분석, 인사이트 리포트 작성</li>
								<li>엑셀 혹은 필요에 따라 조사에 필요한 통계솔루션을 주로 사용 </li>
							</ul>
						</li>
						<li class="conditions">
							<span class="tit">자격</span>
							<ul>
								<li>신입 혹은 경력</li>
								<li>광고홍보, 신문방송, 심리학 및 통계 관련 석사학위 이상 소지자</li>
								<li>연구방법론과 통계프로그램 실무에 조예와 관심이 있는 자</li>
							</ul>
						</li>
						<li class="conditions">
							<span class="tit">우대조건</span>
							<ul>
								<li>모바일게임 이용자 (장르불문)</li>
								<li>온라인/디지털 광고대행사, 미디어렙, 매체에서의 광고 기획 업무 경력 (경력자에 한함)</li>
							</ul>
						</li>
						<li class="conditions">
							<span class="tit">인원</span>
							<ul>
								<li>0 명</li>
							</ul>
						</li>
					</ul>
				</li>
				<li class="job1">
					<h5 class="jobName">User Acquisition Marker</h5>
					<ul class="description">
						<li class="intro">
							<span class="tit">소개</span>
							<span>디지털 미디어를 통해 광고주 사이트, 앱 등으로 소비자를 직접적으로 유입시키고 전환에 이르는 전반의 활동을 계획하고 실행</span>
						</li>
						<li class="position">
							<span class="tit">직무</span>
							<span>광고 관련 솔루션 대시보드 모니터링 및 컨트롤: Facebook business, Google UAC, Apple Search Ad, Ad Network, 3rd party tracker (AppsFlyer, Adjust, Adbrix 등)</span>
						</li>
						<li class="conditions">
							<span class="tit">자격</span>
							<ul>
								<li>미디어렙 또는 디지털 미디어 운영 업무 경력</li>
								<li>구글, 페이스북 매체 운영 경력 및 자격증 소지자 우대</li>
							</ul>
						</li>
						<li class="conditions">
							<span class="tit">인원</span>
							<ul>
								<li>0 명</li>
							</ul>
						</li>
					</ul>
				</li>
			</ul>
		</div>

		<div class="btnPopClose"><a href="#;" @click="$emit('close'), popClose()">닫기</a></div>
		
	</div>
</div>
</template>
<script>
export default {
	created(){
		$('body').addClass('popOpen');
	},
	methods: {
		popClose(){
			$('body').removeClass('popOpen');
		}
	}
}
</script>